const messages = {
  title: "Priežiūros darbai!",
  description:
    'Šiuo metu serveriuose atliekami būtini priežiūros darbai.<br/><br/>Todėl šiuo metu neturite prieigos prie <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Prašome kantrybės ir dėkojame už supratingumą.<br/><br/> Jūsų Bridgestone komanda',
}
export default {
  messages
}
